module.exports = __webpack_public_path__ + "img/public/TrustIcons/Mail.svg?df6f3d3d";